import { useCallback, useMemo } from 'react';
import _ from 'underscore';
import { shortHeadlineMaxLength, longHeadlineMaxLength, descriptionMaxLength } from './perf-max-ad-preview-uapl';

export const useInlinePreviewData = ({
  imageList, previewImagesSharedState, i18n, CallToAction, businessName, descriptions, finalUrls, headlines, longHeadlines,
}) => {
  const { previewLogoId } = previewImagesSharedState;

  const getFirstElement = useCallback((item) => {
    if (_.isArray(item)) {
      return _.first(item);
    }
    return item;
  }, []);

  const curPreviewLogo = useMemo(() => {
    const allLogos = _.filter(imageList, imageArr => getFirstElement(imageArr).isLogo === true);
    let curLogos = previewLogoId && _.find(allLogos, logo => _.first(logo).Id === previewLogoId);
    curLogos = curLogos || _.first(allLogos);

    // currently only square logo is supported, 4x1 logo are ignored
    const curLogoRatio = _.find(curLogos, logo => logo.isIncluded === true && logo.type === 'Image1x1');
    return curLogoRatio;
  }, [getFirstElement, imageList, previewLogoId]);

  const validatedPreviewTexts = useMemo(() => {
    const previewTexts = {
      shortHeadline: headlines && headlines.Headline0,
      longHeadline: longHeadlines && longHeadlines.LongHeadline0,
      description: descriptions && descriptions.Description0,
      businessName,
      callToAction: CallToAction && CallToAction.cta,
      url: _.first(finalUrls),
      logo: curPreviewLogo,
    };

    const validAdData = { ...previewTexts };

    if (validAdData.shortHeadline && validAdData.shortHeadline.length > shortHeadlineMaxLength) {
      validAdData.shortHeadline = validAdData.shortHeadline.substring(0, shortHeadlineMaxLength - 1);
    }

    if (validAdData.longHeadline && validAdData.longHeadline.length > longHeadlineMaxLength) {
      validAdData.longHeadline = validAdData.longHeadline.substring(0, longHeadlineMaxLength - 1);
    }

    if (validAdData.description && validAdData.description.length > descriptionMaxLength) {
      validAdData.description = validAdData.description.substring(0, descriptionMaxLength - 1);
    }

    return _.defaults(validAdData, {
      shortHeadline: i18n.getString(_TL_('Short headline')),
      longHeadline: i18n.getString(_TL_('Long headline')),
      description: i18n.getString(_TL_('Ad text')),
      businessName: i18n.getString(_TL_('Business name')),
      callToAction: i18n.getString(_TL_('Please select language first')),
      url: 'https://example.com',
    });
  }, [CallToAction, businessName, curPreviewLogo, descriptions, finalUrls, headlines, i18n, longHeadlines]);

  return {
    validatedPreviewTexts,
  };
};
